import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ac13681a&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac13681a')) {
      api.createRecord('ac13681a', component.options)
    } else {
      api.reload('ac13681a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ac13681a&", function () {
      api.rerender('ac13681a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/data-dictionary/cartridge-type/index.vue"
export default component.exports